import { type FilterValues } from "components/filters/FilterContext";
import { mapKeywordFilterToInstruction, mapProductGroupFilterToInstruction, mapResponseToKeywordFilter, mapResponseToProductGroupFilter } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedProductTemplateInstruction => {
  return {
    keyword: mapKeywordFilterToInstruction(filter.keyword),
    productGroupIds: mapProductGroupFilterToInstruction(filter.productGroup),
    page,
    perPage,
    cache: filterSet
  };
};

export const mapResponseToFilterValues = (
  response: server.dto.ListProductTemplateFilters
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response?.keyword),
  productGroup: mapResponseToProductGroupFilter(response?.productGroups)
});